module.exports = __webpack_public_path__ + "media/application/images/svgs/cast-6981ed1233759f323a6e5cb85d90be7d.svg";